<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
            <v-breadcrumb value1="首页" value2="廉江特色" value3="田园风光"></v-breadcrumb>
            <div class="container_box mt20 mb20">
                <div class="box_item" >
                    <img src="../../assets/img/01.png">
                    <div class="item_detail">
                        <h3 class="hover" @click="toDetail(dataList[0].path)" style="text-align: center;">{{dataList[0].title}}</h3>
                        <p>{{dataList[0].summary}}</p>
                        <div class="tomore2" style="margin-top: 20px;">
                            <a href="javascript:;" class="xq hover" @click="toDetail(dataList[0].path)" >了解详情</a>
                            <div class="_" ></div>
                        </div>
                    </div>

                </div>
                <div class="box_item" >
                    <img src="../../assets/img/02.png">
                    <div class="item_detail">
                        <h3 class="hover " style="text-align: center;" @click="toDetail(dataList[1].path)">{{dataList[1].title}}</h3>
                        <p>{{dataList[1].summary}}</p>
                        <div class="tomore2" style="margin-top: 20px;">
                            <a href="javascript:;" class="xq hover" @click="toDetail(dataList[1].path)">了解详情</a>
                            <div class="_" ></div>
                        </div>
                    </div>

                </div>
                <div class="box_item" >
                    <img src="../../assets/img/03.png">
                    <div class="item_detail">
                        <h3 class="hover" style="text-align: center;" @click="toDetail(dataList[2].path)">{{dataList[2].title}}</h3>
                        <p>{{dataList[2].summary}}</p>
                        <div class="tomore2" style="margin-top: 20px;">
                            <a href="javascript:;" class="xq hover" @click="toDetail(dataList[2].path)">了解详情</a>
                            <div class="_" ></div>
                        </div>
                    </div>

                </div>
                <div class="box_item" >
                    <img src="../../assets/img/04.png">
                    <div class="item_detail">
                        <h3 class="hover" style="text-align: center;" @click="toDetail(dataList[3].path)">{{dataList[3].title}}</h3>
                        <p>{{dataList[3].summary}}</p>
                        <div class="tomore2" style="margin-top: 20px;">
                            <a href="javascript:;" class="xq hover" @click="toDetail(dataList[3].path)">了解详情</a>
                            <div class="_" ></div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                bindData:[
                    {
                        name:'田园风光',
                        url:'#/tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cecf5a0012'
                    },
                    {
                        name:'赏花观鸟',
                        url:'#/shgn?ljcode=shgn&columnId=40288a9d6e91c70a016e91cefea00013&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cefea00013'
                    },
                    {
                        name:'美丽乡村',
                        url:'#/mlxc?ljcode=mlxc&columnId=40288a9d6e91c70a016e91cf30720014&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        cid:'40288a9d6e91c70a016e91cf30720014'
                    }
                ],
            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = ['tyfg',this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            getList(){
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;
                    console.log(data);
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                    });
                    this.dataList = data;
                })
            },
            toDetail(v){
                this.$router.push({path:`/detail2?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }
    .container_box{
        display: flex;
        flex-direction: row;
        .box_item{
            width: 297px;
            height: 1109px;
            margin-right: 4px;
            background:rgba(179,161,147,1);
            .item_detail{
                color: white;
                h3{
                    margin-top: 89px;
                    margin-bottom: 20px;
                    height: 42px;
                    line-height: 42px;
                    font-size: 30px;
                }
                p{
                    margin: 0 auto;
                    width: 250px;
                    text-align: justify;
                    height: 132px;
                    font-size: 16px;
                    line-height: 22px;
                }
            }
        }
    }
    .container_box :last-child{
        margin-right: 0;
    }
.xq{
       transition: all 0.3s;
}
 .xq:hover{
        transform: scale(1.1);
    }

</style>
